import { useTranslation } from "react-i18next";
import globalStyles from "../../../styles/globalStyles.module.css";
import styles from "./LangSelector.module.css";

const LangSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={styles.centered}>
      <select
        onChange={(e) => changeLanguage(e.target.value)}
        className={`${globalStyles.select} ${styles.customSelect}`}
      >
        <option value="fr">FR</option>
        <option value="en">EN</option>
        <option value="jp">JP</option>
      </select>
    </div>
  );
};

export default LangSelector;
